import React from "react";

import classNames from "classnames/bind";
import Dropdown, { DropdownProps } from "common/blocks/Dropdown";

import styles from "./DropdownWithDescription.module.scss";

const cx = classNames.bind(styles);

type DropdownWithDescriptionProps = DropdownProps & {
    description?: string;
    isHidden?: boolean;
};

const DropdownWithDescription = React.forwardRef<HTMLSelectElement, DropdownWithDescriptionProps>(
    ({ description, isHidden, ...rest }, ref) => {
        return (
            <div className={cx({ isHidden })}>
                <Dropdown ref={ref} {...rest} />
                {!!description && (
                    <div
                        className={cx("descriptionList")}
                        dangerouslySetInnerHTML={{ __html: description }}
                    ></div>
                )}
            </div>
        );
    }
);

DropdownWithDescription.displayName = "DropdownWithDescription";

export default DropdownWithDescription;
